import { Navigate } from 'react-router-dom';
import { isDemoAuthenticated } from '../utils/demoAuth';

export default function RequireDemoAuth({ children }) {
  if (!isDemoAuthenticated()) {
    return <Navigate to="/login" replace state={{ from: '/toolbox' }} />;
  }
  return children;
}
